import ApiException from "@rmp/core/exceptions/apiException";

export default class AccessForbiddenException extends ApiException {
	constructor(public readonly url: string) {
		super(`AccessForbiddenException: ${url}`);
	}
}
